import React from 'react';
import styled from 'styled-components';
import {
  IconButton,
  theme,
  Tooltip,
  color as colors
} from '@workboard/wobo-ui';
import HelpOutline from '@material-ui/icons/HelpOutline';
import { useTranslation } from 'react-i18next';

const Label = styled('h2')``;

const Title = props => { 
  const { t } = useTranslation();
  return (
  <div {...props} >
    <Label>{props.title}</Label>
    <Tooltip
        content={<span><Trans i18nKey="engagementReport.teamsTooltip" /></span>}
        isTitle={false}
        placement='bottom'
        arrow
      >
        <IconButton aria-label='help text button'>
          <HelpOutline />
        </IconButton>
    </Tooltip>
  </div>
);
} 

export default styled(Title)`
  display: flex;
  alignItems: center;

  ${Label} {
    ${theme('--font-large')}
    color: ${colors('--black-opacity-60')};
    font-weight: bold;
    margin: 0;
  }

  ${Tooltip} {
    padding: 0;
    margin-left: 8px;
    transform: scale(0.8);
  }
`;
